module.exports = __webpack_public_path__ + "img/czsc_17.4481071a.png";